import { ref, getDatabase, get, update, remove } from 'firebase/database';
import type { DataSnapshot, DatabaseReference } from 'firebase/database'
import Environment from '../../utils/Environement';

import DeliverooApi from "../api/DeliverooApi";
import { StoreActionType } from '../constant/ActionConstant';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Service, { ServiceInterface } from '../model/service/Service';
import { getAuth } from 'firebase/auth';

const kDeliveraKey = 'delivera';
const kDeliverooKey = 'deliveroo';
const kLoginKey = 'login';

class DeliverooActionCreator {

    private api: DeliverooApi

    constructor() {
        this.api = new DeliverooApi(Environment.isDev);
    }

    async loadDeliverooServiceUser() {
        const auth = getAuth()
        const useruid = auth.currentUser?.uid
        if (useruid === undefined) {
            throw new Error("error firebase not connected");
        }
        try {
            const db = getDatabase();
            const reference: DatabaseReference = ref(db, kDeliveraKey + '/' + useruid + '/' + kDeliverooKey + '/' + kLoginKey);
            const snapshot: DataSnapshot = await get(reference);
            const serviceUser = (snapshot.exists()) ? new Service(snapshot.val()) : new Service();
            AppDispatcher.dispatch({
                'type': StoreActionType.SET_DELIVEROO_SERVICE,
                'data': serviceUser
            });
        }
        catch (e) {
            throw e;
        }
    }

    async connectDeliverooServiceUser(apiKey: string, apiSecret: string) {
        const auth = getAuth()
        const useruid = auth.currentUser?.uid
        if (useruid === undefined) {
            throw new Error("error firebase not connected");
        }
        try {
            await this.api.testAuthenticationOnApi(apiKey, apiSecret);
            const serviceData: ServiceInterface = { locationId: apiKey, uid: useruid, isActive: true, service: 'deliveroo', name: apiSecret, last_updates: [] };
            const service = new Service(serviceData);
            const db = getDatabase();
            const reference = ref(db, kDeliveraKey + '/' + useruid + '/' + kDeliverooKey + '/' + kLoginKey);
            await update(reference, service.toJS());
            AppDispatcher.dispatch({
                'type': StoreActionType.SET_DELIVEROO_SERVICE,
                'data': service
            });
        }
        catch (e) {
            throw e;
        }
    }

    async disconnectDeliverooService() {
        const auth = getAuth()
        const useruid = auth.currentUser?.uid
        if (useruid === undefined) {
            throw new Error("error firebase not connected");
        }
        try {
            const db = getDatabase();
            const reference = ref(db, kDeliveraKey + '/' + useruid + '/' + kDeliverooKey + '/' + kLoginKey);
            await remove(reference);
            AppDispatcher.dispatch({
                'type': StoreActionType.SET_DELIVEROO_SERVICE,
                'data': new Service()
            });
        }
        catch (e) {
            throw e;
        }
    }

}

const deliverooActionCreator = new DeliverooActionCreator();
export default deliverooActionCreator;